import { useState } from "react";
import iconOlhoAberto from "../imagem/iconOlhoAberto.svg";
import iconOlhoFechado from "../imagem/iconOlhoFechado.svg";

export default function InputSenha({ value, changeValue, placeholder }) {
  const [exibirSenha, setExibirSenha] = useState(false);

  const estiloDiv = {
    backgroundColor: "var(--cor-branco)",
    border: "1px solid var(--cor-cinzaMargin)",
    marginTop: 5,
    margin: "none",
    borderRadius: 10,
    width: "100%",
    height: 45,
    fontFamily: "Roboto",
  };

  return (
    <div className="input_senha" style={estiloDiv}>
      <input
        style={{ fontSize: 20, color: "var(--cor-preto)" }}
        type={exibirSenha ? "text" : "password"}
        value={value}
        onChange={(e) => changeValue(e.target.value)}
        placeholder={placeholder}
      />
      <button onClick={() => setExibirSenha(!exibirSenha)}>
        <img
          src={!exibirSenha ? iconOlhoAberto : iconOlhoFechado}
          alt="Visualizar senha"
        />
      </button>
    </div>
  );
}
